import * as fmt from "./fmt"
;(globalThis as any).fmt = fmt
export * from "./fmt"
